/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { Text, View } from '@az/starc-ui';
import { useLabels } from '@/hooks/useLabels';
import { useLocale } from '@/hooks/useLocale';
import styles from '../styles.module.scss';

const labelMap = {
  purchased: 'label_buyAgain_purchasedDate_purchased',
};

const formatTransactionDate = (dateString: string, locale: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString(locale, { month: 'short', year: 'numeric' });
};

export const PurchasedDate = ({ purchasedDate }: { purchasedDate: string }) => {
  const labels = useLabels(labelMap);
  const locale = useLocale();

  return (
    <View className={styles.purchaseDateContainer}>
      <Text variant="small-body" className={styles.purchaseDate}>
        {labels.purchased} {formatTransactionDate(purchasedDate, locale)}
      </Text>
    </View>
  );
};
